import { render } from "./ListeFactureProformaPage.vue?vue&type=template&id=7fcd94c6&ts=true"
import script from "./ListeFactureProformaPage.vue?vue&type=script&lang=ts"
export * from "./ListeFactureProformaPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__